"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenInlineEditMultilineField = void 0;
const React = __importStar(require("react"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const material_1 = require("@mui/material");
const fc_1 = require("react-icons/fc");
const vsc_1 = require("react-icons/vsc");
const styled_components_1 = __importDefault(require("styled-components"));
const ButtonIcon = (0, styled_components_1.default)(material_1.Icon) `
	cursor: pointer;
`;
function KodenInlineEditMultilineField(_a) {
    var { id, onConfirm, defaultValue, maxRows } = _a, props = __rest(_a, ["id", "onConfirm", "defaultValue", "maxRows"]);
    const [value, setValue] = React.useState(defaultValue);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const inputRef = React.useRef();
    const open = Boolean(anchorEl);
    const onOk = () => {
        onConfirm(value);
        setAnchorEl(null);
    };
    const onCancel = () => {
        setValue(defaultValue);
        setAnchorEl(null);
    };
    const inputProps = {};
    if (props === null || props === void 0 ? void 0 : props.maxLength) {
        // @ts-ignore
        inputProps.maxLength = props.maxLength;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(material_1.ClickAwayListener, { onClickAway: () => {
                    onCancel();
                } },
                React.createElement("div", { onClick: (event) => {
                        if (anchorEl === null) {
                            setAnchorEl(event.currentTarget);
                        }
                    } },
                    React.createElement(TextField_1.default, { id: id, ref: inputRef, multiline: true, maxRows: maxRows, disabled: false, inputProps: inputProps, variant: "standard", value: value, onChange: (event) => {
                            setValue(event.target.value);
                        } }),
                    open && (React.createElement("div", { style: {
                            marginTop: 6,
                            display: "flex",
                            justifyContent: "flex-end",
                        } },
                        React.createElement(ButtonIcon, { style: { marginRight: 6 }, onClick: (event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                onOk();
                            } },
                            React.createElement(fc_1.FcCheckmark, null)),
                        React.createElement(ButtonIcon, { onClick: (event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                onCancel();
                            } },
                            React.createElement(vsc_1.VscError, { style: { color: "red" } })))))))));
}
exports.KodenInlineEditMultilineField = KodenInlineEditMultilineField;
//# sourceMappingURL=koden-inline-edit-multiline-field.js.map